import { StoreAppDispatch } from "..";
import { SET_SUCCESS_MODE } from "../UI/successModeSlice";

export const showSuccessWithTimeout = (message?: string) => (dispatch: StoreAppDispatch) => {
    dispatch(SET_SUCCESS_MODE({ enabled: true, message: message ?? "" }));

    setTimeout(() => {
      dispatch(SET_SUCCESS_MODE(false));
    }, 3000);
};